import { render, staticRenderFns } from "./Goretski.vue?vue&type=template&id=75e6e282"
import script from "./Goretski.vue?vue&type=script&lang=js"
export * from "./Goretski.vue?vue&type=script&lang=js"
import style0 from "./Goretski.vue?vue&type=style&index=0&id=75e6e282&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports